module.exports = __webpack_public_path__ + "static/media/plus_gray.c68710c5.svg";